var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card)?_c('div',{staticClass:"duedate"},[_c('transition',{attrs:{"name":"zoom"}},[(_vm.card.duedate)?_c('div',{class:_vm.dueIcon,attrs:{"title":_vm.absoluteDate}},[_c('span',[_vm._v(_vm._s(_vm.relativeDate))])]):_vm._e()])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }